// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Colores base */
.text-orange[data-v-d9ff3d28] {
  color: #ff8800 !important;
}

/* Botones */
.btn-orange[data-v-d9ff3d28] {
  background-color: #ff8800 !important;
  border-color: #ff8800 !important;
  color: white !important;
  font-weight: 500;
}
.btn-orange[data-v-d9ff3d28]:hover {
  background-color: #e67a00 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Tabla */
.minimal-table[data-v-d9ff3d28] thead th {
  background-color: #f8f9fa;
  color: #666;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Estilo de la "Card" dentro del Modal similar a la imagen */
.content-card[data-v-d9ff3d28] {
  border: 1px solid #ffd8a8;
}
.card-header-custom[data-v-d9ff3d28] {
  background-color: #fffaf4;
}
.bg-history[data-v-d9ff3d28] {
  background-color: #fffdfa; /* Fondo muy claro casi blanco/crema */
}

/* Texto del mensaje */
.message-text[data-v-d9ff3d28] {
  white-space: pre-wrap;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.95rem;
  color: #444;
  line-height: 1.6;
}
.footer-metadata[data-v-d9ff3d28] {
  font-size: 0.8rem;
  opacity: 0.7;
}

/* Visor de Payload cuando no hay historia */
.json-payload[data-v-d9ff3d28] {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  font-size: 0.85rem;
  color: #333;
  max-height: 400px;
  overflow: auto;
  border: 1px solid #eee;
}

/* Listas y Alertas */
.custom-list[data-v-d9ff3d28] {
  list-style-type: none;
  padding-left: 0;
}
.custom-list li[data-v-d9ff3d28]::before {
  content: "•";
  color: #dc3545;
  font-weight: bold;
  display: inline-block;
  width: 1em;
}

/* Ajustes generales del modal */
[data-v-d9ff3d28] .modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
[data-v-d9ff3d28] .modal-header .btn-close {
  font-size: 1.2rem;
}
.uppercase-label[data-v-d9ff3d28] {
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.5px;
  font-weight: 700;
}
.error-meta-summary[data-v-d9ff3d28] {
  background-color: #fcfcfc !important;
}
.meta-item[data-v-d9ff3d28] {
  min-width: 120px;
}

/* Mejora la separación visual del modal */
.errors-section[data-v-d9ff3d28] {
  border-top: 1px dashed #dee2e6;
  padding-top: 10px;
}

/* Ajuste para que el badge dentro del modal no sea tan grande */
.meta-item .badge[data-v-d9ff3d28] {
  font-size: 0.8rem;
  padding: 5px 10px;
}
.error-message-box[data-v-d9ff3d28] {
  background-color: #fff5f5; /* Un rojo/rosa muy suave */
  border-left: 4px solid #dc3545; /* Barra lateral roja de peligro */
}
.text-danger-emphasis[data-v-d9ff3d28] {
  color: #a52834;
  font-style: italic;
  font-size: 0.95rem;
}
.italic[data-v-d9ff3d28] {
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/PanelErrores.vue"],"names":[],"mappings":";AAgOA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;AAClB;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,4DAA4D;EAC5D,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,eAAe;AACjB;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;AAEA;EACE,oCAAoC;AACtC;AAEA;EACE,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,8BAA8B,EAAE,kCAAkC;AACpE;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["\n/* Colores base */\n.text-orange {\n  color: #ff8800 !important;\n}\n\n/* Botones */\n.btn-orange {\n  background-color: #ff8800 !important;\n  border-color: #ff8800 !important;\n  color: white !important;\n  font-weight: 500;\n}\n\n.btn-orange:hover {\n  background-color: #e67a00 !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n/* Tabla */\n.minimal-table :deep(thead th) {\n  background-color: #f8f9fa;\n  color: #666;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Estilo de la \"Card\" dentro del Modal similar a la imagen */\n.content-card {\n  border: 1px solid #ffd8a8;\n}\n\n.card-header-custom {\n  background-color: #fffaf4;\n}\n\n.bg-history {\n  background-color: #fffdfa; /* Fondo muy claro casi blanco/crema */\n}\n\n/* Texto del mensaje */\n.message-text {\n  white-space: pre-wrap;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 0.95rem;\n  color: #444;\n  line-height: 1.6;\n}\n\n.footer-metadata {\n  font-size: 0.8rem;\n  opacity: 0.7;\n}\n\n/* Visor de Payload cuando no hay historia */\n.json-payload {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 5px;\n  font-size: 0.85rem;\n  color: #333;\n  max-height: 400px;\n  overflow: auto;\n  border: 1px solid #eee;\n}\n\n/* Listas y Alertas */\n.custom-list {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.custom-list li::before {\n  content: \"•\";\n  color: #dc3545;\n  font-weight: bold;\n  display: inline-block;\n  width: 1em;\n}\n\n/* Ajustes generales del modal */\n:deep(.modal-content) {\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n:deep(.modal-header .btn-close) {\n  font-size: 1.2rem;\n}\n\n.uppercase-label {\n  text-transform: uppercase;\n  font-size: 0.7rem;\n  letter-spacing: 0.5px;\n  font-weight: 700;\n}\n\n.error-meta-summary {\n  background-color: #fcfcfc !important;\n}\n\n.meta-item {\n  min-width: 120px;\n}\n\n/* Mejora la separación visual del modal */\n.errors-section {\n  border-top: 1px dashed #dee2e6;\n  padding-top: 10px;\n}\n\n/* Ajuste para que el badge dentro del modal no sea tan grande */\n.meta-item .badge {\n  font-size: 0.8rem;\n  padding: 5px 10px;\n}\n\n.error-message-box {\n  background-color: #fff5f5; /* Un rojo/rosa muy suave */\n  border-left: 4px solid #dc3545; /* Barra lateral roja de peligro */\n}\n\n.text-danger-emphasis {\n  color: #a52834;\n  font-style: italic;\n  font-size: 0.95rem;\n}\n\n.italic {\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
